/**
 * スネークラインメッシュのメッシュIDを表すプロパティ
 * メッシュの基となる地理情報ファイルによって変わる可能性がある
 * @module app/map/snakeline/KeyName
 */
 define({
    keyName: 'THREE_MESH'
});
